<template>
  <Component :is="tag" class="base-layout-container">
    <div class="base-layout-container-inner" :class="[innerClass, `size-${size}`]">
      <slot />
    </div>
  </Component>
</template>

<script lang="ts" setup>
interface Props {
  innerClass?: string
  tag?: string
  size?: 'default' | 'middle'
}
withDefaults(defineProps<Props>(), {
  innerClass: '',
  tag: 'div',
  size: 'default',
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.base-layout-container {
  width: 100%;
}

.base-layout-container-inner {
  width: 100%;
  padding-left: 16px;
  padding-right: 16px;
  margin-left: auto;
  margin-right: auto;

  @include is-tablet {
    min-width: 768px;
    padding-left: 24px;
    padding-right: 24px;

    &.size-default {
      max-width: 1200px;
    }

    &.size-middle {
      max-width: 912px;
    }
  }

  @include is-print {
    margin-left: auto;
    margin-right: auto;
    width: auto;
    padding-left: 0;
    padding-right: 0;
    min-width: 100%;
  }
}
</style>

<style lang="scss">
@use '@/assets/styles/scss/vue' as *;

.base-layout-full-width-cancel {
  .base-layout-container {
    width: 100%;
    @include is-tablet {
      width: auto;
      padding-left: 0;
      padding-right: 0;
    }
  }

  .base-layout-container-inner {
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
    @include is-tablet {
      margin-left: calc(0.25rem * 4);
      margin-right: calc(0.25rem * 4);
      padding-left: 0;
      padding-right: 0;
    }
  }
}
</style>
